









import { Mixins } from 'vue-mixin-decorator'
import { Component, Prop } from 'vue-property-decorator'

import ExternalLogin from '@/components/organisms/external-login/ExternalLogin.vue'
import LoadingMixin from '@spa/mixins/loading'
import { PluginMixin } from '@spa/mixins/plugin'

import {
  externalButtonDisplayOrder,
  isExternalLoginEnabled,
} from '@spa/router/externalLogin'

Component.registerHooks([
  'beforeRouteEnter',
])

@Component({
  components: {
    ExternalLogin,
  },
  mixins: [
    LoadingMixin,
  ],
})
export default class ShortcutLoginArea extends Mixins<PluginMixin>(PluginMixin) {
  @Prop({ required: true })
  redirectEndpoint: string

  get shouldShowExternalLoginButtonArea(): boolean {
    return isExternalLoginEnabled()
  }

  get brandsMaybeEnableExternalLogin(): string[] {
    return externalButtonDisplayOrder()
  }
}
